(() => {
  const SELECTOR = '[data-digi-pack-fixo]';

  const parseProducts = (value) => {
    try {
      const products = JSON.parse(value || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      console.warn('[Digi Pack Fixo] Produtos inválidos.', error);
      return [];
    }
  };

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const input = document.createElement('textarea');

    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';

    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  const initSection = (section) => {
    if (!section || section.dataset.packFixoReady === 'true') {
      return;
    }

    section.dataset.packFixoReady = 'true';

    const grid = section.querySelector('[data-pack-fixo-grid]');

    const prev = section.querySelector('[data-pack-fixo-prev]');

    const next = section.querySelector('[data-pack-fixo-next]');

    const status = section.querySelector('[data-pack-fixo-status]');

    if (!grid) return;

    const updateNav = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth;

      const current = Math.abs(grid.scrollLeft);
      const hasOverflow = maxScroll > 2;

      if (prev) {
        prev.hidden = !hasOverflow || current <= 10;
      }

      if (next) {
        next.hidden = !hasOverflow || current >= maxScroll - 10;
      }
    };

    const getScrollAmount = () => {
      const firstCard = grid.querySelector('[data-pack-fixo-card]');

      if (!firstCard) {
        return grid.clientWidth;
      }

      const styles = getComputedStyle(grid);

      const gap = parseFloat(styles.columnGap || styles.gap || '0');

      const visibleCards = window.matchMedia('(min-width: 768px)').matches ? 3 : 1;

      return (firstCard.getBoundingClientRect().width + gap) * visibleCards;
    };

    const scroll = (direction) => {
      grid.scrollBy({
        left: getScrollAmount() * direction,
        behavior: 'smooth',
      });
    };

    prev?.addEventListener('click', () => scroll(-1));

    next?.addEventListener('click', () => scroll(1));

    grid.addEventListener('scroll', updateNav, { passive: true });

    const resizeObserver = new ResizeObserver(updateNav);

    resizeObserver.observe(grid);

    section.addEventListener('click', async (event) => {
      const couponButton = event.target.closest('[data-copy-coupon]');

      if (couponButton && section.contains(couponButton)) {
        const code = couponButton.dataset.couponCode?.trim();

        if (!code) return;

        try {
          await copyText(code);

          const label = couponButton.querySelector('[data-coupon-label]');

          const originalLabel = label?.textContent;

          if (label) {
            label.textContent = 'COPIADO!';
          }

          if (status) {
            status.textContent = `Cupom ${code} copiado.`;
          }

          window.setTimeout(() => {
            if (label) {
              label.textContent = originalLabel;
            }
          }, 1800);
        } catch (error) {
          console.warn('[Digi Pack Fixo] Não foi possível copiar o cupom.', error);

          if (status) {
            status.textContent = `Não foi possível copiar o cupom ${code}.`;
          }
        }

        return;
      }

      const openButton = event.target.closest('[data-open-fixed-pack-modal]');

      if (!openButton || !section.contains(openButton)) {
        return;
      }

      const card = openButton.closest('[data-pack-fixo-card]');

      const products = parseProducts(openButton.dataset.products);

      const comboKey = openButton.dataset.comboKey?.trim();

      if (products.length === 0) {
        console.warn('[Digi Pack Fixo] Configure ao menos um produto no combo.');

        return;
      }

      if (!comboKey) {
        console.warn(
          '[Digi Pack Fixo] O combo está sem identificador. ' +
            'O modal será aberto, mas preencha o campo ' +
            '"Identificador do combo" antes de integrar ao carrinho.',
        );
      }

      document.dispatchEvent(
        new CustomEvent('digi:open-fixed-pack-modal', {
          detail: {
            version: 'fixed-pack-v1',
            source: 'digi-pack-fixo',

            sectionId: section.dataset.sectionId || '',

            influencerKey: section.dataset.influencerKey?.trim() || '',

            blockId: card?.dataset.blockId || '',

            comboKey,

            comboTitle: openButton.dataset.comboTitle || '',

            badge: openButton.dataset.badge || '',

            couponCode: openButton.dataset.couponCode || '',

            discount: {
              type: openButton.dataset.discountType === 'fixed_amount' ? 'fixed_amount' : 'percentage',

              value: Math.max(0, Number(openButton.dataset.discountValue) || 0),
            },

            parentVariantId: Number(openButton.dataset.parentVariantId) || null,

            gift: {
              enabled: openButton.dataset.giftEnabled === 'true',

              badge: openButton.dataset.giftBadge || 'LIBERADO!',

              productId: Number(openButton.dataset.giftProductId) || null,

              variantId: Number(openButton.dataset.giftVariantId) || null,

              productTitle: openButton.dataset.giftTitle || '',

              image: openButton.dataset.giftImage || '',

              priceCents: Number(openButton.dataset.giftPriceCents) || 0,

              compareLabel: openButton.dataset.giftCompareLabel || '',

              priceLabel: openButton.dataset.giftPriceLabel || '',

              background: openButton.dataset.giftBackground || '#f8ffe5',

              border: openButton.dataset.giftBorder || '#d4ff3f',

              titleColor: openButton.dataset.giftTitleColor || '#143740',

              priceColor: openButton.dataset.giftPriceColor || '#143740',

              badgeBackground: openButton.dataset.giftBadgeBackground || '#91a839',

              badgeText: openButton.dataset.giftBadgeText || '#ffffff',

              qty: Number(openButton.dataset.giftQty) || 1,
            },

            products,
          },
        }),
      );
    });

    updateNav();
  };

  const initAll = (root = document) => {
    if (root.matches?.(SELECTOR)) {
      initSection(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
